/* eslint-disable max-len */
/* eslint-disable quote-props */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/quotes */
import { Injectable } from '@angular/core';
import { BlockService } from 'src/app/services/block.service';

@Injectable({ providedIn: 'root' })
export class TinyMceService {
  tinyMCEConfiguration;

  blockArray = [];
  blocks = [];

  constructor( private blockService: BlockService ) {
    this.onListBlocks();
    // console.log(this.blocks);
  }


  example_image_upload_handler = (blobInfo, progress) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', 'postAcceptor.php');

    xhr.upload.onprogress = (e) => {
      progress(e.loaded / e.total * 100);
    };

    xhr.onload = () => {
      if (xhr.status === 403) {
        reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
        return;
      }

      if (xhr.status < 200 || xhr.status >= 300) {
        reject('HTTP Error: ' + xhr.status);
        return;
      }

      const json = JSON.parse(xhr.responseText);

      if (!json || typeof json.location != 'string') {
        reject('Invalid JSON: ' + xhr.responseText);
        return;
      }

      resolve(json.location);
    };

    xhr.onerror = () => {
      reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
    };

    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  });

  filePickerCallBack(cb) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.onchange = function(e?: HTMLInputEvent) {
      const file = e.target.files[0];
      console.log(file);
      const reader = new FileReader();
      reader.onload = function(event) {
        console.log("tinymce",event);
        const blobCache =  event.target.result;
        console.log(blobCache);
        const blobInfo = blobCache;
        cb(blobInfo, { title: file.name });
      };
      reader.readAsDataURL(file);
    };

    input.click();
    interface HTMLInputEvent extends Event {
      target: HTMLInputElement & EventTarget;
    }
  }

  block(){
    console.log(this.blockArray);
  }

  tinyMCEConfig() {
    this.tinyMCEConfiguration = {
      custom_elements: 'custom, ion-slides',
      // extended_valid_elements: 'custom',
      extended_valid_elements: 'custom, ion-slides[[options]|#slideWithNav2|(ionSlideDidChange)|autoplay|speed|pager]',
      valid_elements: '*[*]',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      base_url: '/tinymce',
      setup(editor) {
        /* Menu items are recreated when the menu is closed and opened, so we need
           a variable to store the toggle menu item state. */
        const toggleState = false;

        /* example, adding a toolbar menu button */
        editor.ui.registry.addMenuButton('mybutton', {
          text: 'My button',
          fetch(callback) {

            const items = [];
            for (const item of this.blockArray) {
              const menuItem = {
                type: 'menuitem',
                text: item.title,
                onAction() {
                  editor.insertContent('{' + item.codeword + '}');
                }
              };
              items.push(menuItem);
            };
            callback(items);
          }
        });

      },
      content_css: '/styles.css',
      suffix: '.min',
      height: 700,
      menubar: false,
      image_dimensions: false,
      images_upload_url: 'postAcceptor.php',
      add_unload_trigger: false,
      style_formats:[
        {title: 'Text Styles', items: [
           {title: "Paragraph",format: "p"},
          {title: "Header 1",format: "h1"},
          {title: "Header 2",format: "h2"},
          {title: "Header 3",format: "h3"},
          {title: "Header 4",format: "h4"},
          {title: "Header 5",format: "h5"},
          {title: "Header 6",format: "h6"}
       ]},
       {title: 'Image Formatting', items: [
         {title: 'Image Left', selector: 'img',
           styles: {
             'float' : 'left',
             'margin': '0 10px 10px 0px'
           }
         },
         {title: 'Image Right', selector: 'img',
           styles: {
             'float' : 'right',
             'margin': '0 0 10px 10px'
           }
         },
         {title: 'Image Centre', selector: 'img',
           styles: {
             'display' : 'block',
             'margin' : 'auto'
           }
         }
       ]},
       {title: 'Font Size', items: [
         {title : '8px', inline : 'span', styles : {'font-size' : '8px'}},
         {title : '10px', inline : 'span', styles : {'font-size' : '10px'}},
         {title : '12px', inline : 'span', styles : {'font-size' : '12px'}},
         {title : '14px', inline : 'span', styles : {'font-size' : '14px'}},
         {title : '16px', inline : 'span', styles : {'font-size' : '16px'}},
         {title : '18px', inline : 'span', styles : {'font-size' : '18px'}}
       ]}
      ],
      images_upload_handler: this.example_image_upload_handler,
      images_upload_credentials: true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      file_picker_callback: this.filePickerCallBack,

      plugins: [ "image", "code", "table", "link", "media", "codesample", "advlist", "lists", "wordcount", "visualblocks"],

      toolbar: 'styles | undo redo | forecolor backcolor | bold italic hr | alignleft aligncenter alignright alignjustify | link image | bullist numlist outdent indent | visualblocks media code | mybutton',

    };
  }

  async onListBlocks() {
    const list = this.blockService.loadLiveList();
    const subscription = list.valueChanges({idField: 'id'}).subscribe(async (ss) => {
      this.blockArray = ss;
      this.block();
      //console.log(this.blockArray);
      // return(this.blockArray);
    });
    await this.tinyMCEConfig();

  }


}
